import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { addListToDropdown, createDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import selected from './selected';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import translations from './lang/translations';
import imageIcon from "../insert_ai/icon/robot-line-icon.svg";
import imageIconLandscape from "../change_orientation/icon/orientation_landscape.svg";
export default class InsertAi extends Plugin {
    init() {
        translations();
        const editor = this.editor;
        const { t } = editor.locale;
        editor.ui.componentFactory.add( 'insertAi', locale => {
            const view = new ButtonView( locale );
            view.set( {
                label: window.trans.lms.InsertAIContent,
                icon: imageIcon,
                tooltip: true,
                isEnabled: true,
            } );

            view.on( 'execute', (evt) => {

                // save id of button on which user clicked, so we know in which ckeditor to insert text
                document.getElementById('last_clicked_ai_button_id').value = view.viewUid

                document.getElementById('ai_question').value = ""
                let aiAnswerElement = document.getElementById('ai_answer')
                aiAnswerElement.value = ""
                $('#aiModal').modal('show');

                document.getElementById('ai_save_button', ).addEventListener('click', function() {
                    // const docFrag = editor.model.change( writer => {
                    //     const docFrag = writer.createDocumentFragment();
                    //
                    //     writer.append(aiAnswerElement.value, docFrag)
                    //     return docFrag;
                    // } );
                    // editor.model.insertContent(docFrag, editor.model.document.selection);

                    let text = aiAnswerElement.value;
                    text = text.replaceAll('\n', '<br/>')
                    const viewFragment = editor.data.processor.toView(text);
                    const modelFragment = editor.data.toModel( viewFragment );

                    // add content to right ckeditor
                    if (view.viewUid === document.getElementById('last_clicked_ai_button_id').value) {
                        editor.model.insertContent( modelFragment, editor.model.document.selection );
                    }

                    $('#aiModal').modal('hide');
                })

            });

            return view;
        } );
    }

}